import { Flower2 } from "lucide-react";

export default function GreetingCardPreview({ note, sender }) {
  if (!note?.trim()) return null;
  return (
    <div data-testid="greeting-card-preview" className="mt-4 animate-in fade-in duration-300">
      <span className="text-[10px] uppercase tracking-widest text-[#7E8F7A] font-semibold block mb-2">
        Pratinjau Kartu Ucapan
      </span>
      <div className="relative mx-auto max-w-sm rounded-2xl bg-[#FFFDF8] border border-[#E4D9C3] shadow-[0_10px_30px_-12px_rgba(61,90,64,0.35)] p-6 sm:p-7 overflow-hidden">
        <div className="pointer-events-none absolute inset-2 rounded-xl border border-[#D9CDB3]" />
        <div className="pointer-events-none absolute -top-6 -right-6 w-24 h-24 rounded-full bg-[#F1E7D3] opacity-70" />
        <div className="pointer-events-none absolute -bottom-8 -left-8 w-28 h-28 rounded-full bg-[#E4EEE2] opacity-70" />
        <div className="relative text-center">
          <Flower2 className="w-5 h-5 text-[#3D5A40] mx-auto mb-3" />
          <p
            data-testid="greeting-card-text"
            className="font-serif-display italic text-base sm:text-lg leading-relaxed text-[#1E2B1D] whitespace-pre-wrap break-words"
          >
            “{note}”
          </p>
          <div className="mt-4 flex items-center justify-center gap-2">
            <span className="h-px w-8 bg-[#D9CDB3]" />
            <span className="text-[10px] uppercase tracking-widest text-[#7E8F7A]">
              {sender?.trim() ? `Dari ${sender.trim()}` : "Dengan kasih"}
            </span>
            <span className="h-px w-8 bg-[#D9CDB3]" />
          </div>
          <span className="block mt-3 text-[9px] uppercase tracking-[0.25em] text-[#B3A98F]">
            Puspita Florist
          </span>
        </div>
      </div>
    </div>
  );
}
